import { useKeyboardState } from "react-native-keyboard-controller";

export const useKeyboardVisible = () => {
    const keyboardState = useKeyboardState();
    return keyboardState.isVisible;
};
